import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Podlaskie() {
  return (
    <>
      <DisplayMaster voivodeship="Podlaskie" />
    </>
  );
}